export default __webpack_public_path__ + "static/media/Blood-Glucose.c26d6844.svg";